import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export default function AuthLayout() {
  const { firebaseUser, initialized, sessionConflict, sessionChecking, pendingEmailVerification } = useAuthStore();
  const location = useLocation();

  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-900 text-white">
        <div className="animate-pulse text-lg">Loading...</div>
      </div>
    );
  }

  // Already logged in → go to main (but stay if session conflict pending, session check in progress,
  // or on the email verification page)
  const isVerifyPage = location.pathname === '/verify-email';
  if (firebaseUser && !sessionConflict && !sessionChecking && !isVerifyPage && !pendingEmailVerification) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col text-white"
      style={{ backgroundColor: '#0a0a0f', paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <Outlet />
    </div>
  );
}
